import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectFutureMapVisible } from '../../../selectors/newbuildingMap';
import { IInfrastructureData } from '../../../types/map';
import { hasFutureObjects } from '../utils';
import { toInfrastructureItems } from '../utils/mappers';

export const useFutureInfrastructure = (
  infrastructureByYearRef: React.MutableRefObject<Map<number, IInfrastructureData>>,
) => {
  const isFutureMapVisible = useSelector(selectFutureMapVisible);

  return React.useMemo(() => {
    const infrastructureItems = toInfrastructureItems(infrastructureByYearRef.current);

    return isFutureMapVisible && hasFutureObjects(infrastructureItems);
  }, [infrastructureByYearRef.current, isFutureMapVisible]);
};
